if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");

        this.itemCount = document.getElementById("cart-notification-count-item-cart");


        //console.log(this.cartNotification);
      }
      

      

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }



        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            let cartItemCount = parseInt(
              this.getSectionInnerHTML(parsedState.sections["cart-notification-count"])
            );

            var contactId = "{{ settings.price_to_free_shipping }}";
          console.log(contactId);

            let cartTotal = this.getSectionInnerHTML(parsedState.sections["cart-notification-subtotal"]);
            var currentVal = cartTotal.replace(/[$USD,.]/g,'');

            var itemCount = document.querySelector('.cart-notification-count-item-cart');
            itemCount.textContent = cartItemCount;
            
           
            // var targetVal = 150000;
            var progressBar = document.querySelector('.cart-shipping-progress');
            var progressNum = document.querySelector('.cart-shipping-num');
            var progressOuter = document.querySelector('.cart-shipping-num-inner');
            var successMsg = document.querySelector('.cart-shipping-success');

            var targetVal = document.getElementById("price-free").getAttribute('data-price-free');
           
  
            var result = Math.round(100 * currentVal / targetVal);
  
            progressBar.setAttribute('style', "width: ".concat(result, "%"));
  
            var newProgressNum = (targetVal - currentVal) / 100;
            if(targetVal <= currentVal){
              successMsg.style.display = 'flex';
              progressOuter.style.display = 'none';
              progressNum.textContent = newProgressNum;
            } else {
              successMsg.style.display = 'none';
              progressOuter.style.display = 'flex';
              progressNum.textContent = newProgressNum;
            }

            document.querySelector(".product-form-error-message-wrapper")?.classList.add("no-js-inline");
          })
          // .catch((e) => {
          //   console.error(e);
          // })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
          
          

      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form-error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
